import { CheckIcon } from "@/components/ui/icon";
import { Checkbox, CheckboxIndicator, CheckboxIcon } from "@/components/ui/checkbox";
import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import React, { useState, useEffect } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import { useSelector } from "react-redux";

import i18n from "i18n-js";

export const ChannelLinkedPreference = (modal) => {
  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  if (isAcknowledged) {
    modal.onClose();
  }

  const all_workflows_lookup = useSelector((state) => state.workflows);
  const all_workflows_owned = Object.fromEntries(Object.entries(all_workflows_lookup).filter(([key, value]) => value.owned && !value.deleted));
  const all_workflows = Object.values(all_workflows_owned);
  const all_contacts = useSelector((state) => state.contacts.active);

  const channel = useSelector((state) => state.contacts.channels) //
    .filter(_ => _.id === modal.option?.channel?.id)[0] ?? {};

  const [modal_title, setModalTitle] = useState();
  const [modal_caption, setModalCaption] = useState();
  const [input_linked, setInputLinked] = useState({});

  useEffect(() => {
    if (channel?.id) {
      switch (modal.type) {
        case 'channel:update-workflows': {
          const entries = {};

          for (const k in channel.workflows) {
            const local_workflow_id = channel.workflows[k];
            entries[local_workflow_id] = all_workflows_owned[local_workflow_id];
          }

          setModalTitle(i18n.t('contact.workflowsN', { num: channel.workflows.length }));
          setModalCaption(i18n.t('channel.addWorkflowsText'));
          setInputLinked({ workflows: entries });

          break;
        }
        case 'channel:update-members': {
          const entries = {};

          for (const k in channel.contacts) {
            const contact_id = channel.contacts[k];
            entries[contact_id] = all_contacts[contact_id];
          }

          setModalTitle(i18n.t('channel.contacts', { num: channel.contacts.length }));
          setModalCaption(i18n.t('channel.addContactText'));
          setInputLinked({ contacts: entries });

          break;
        }
      }
    }
  }, [channel]);

  useEffect(() => {
    if (channel?.id && Object.keys(input_linked).length >= 1) {
      switch (modal.type) {
        case 'channel:update-workflows': {
          setModalTitle(i18n.t('contact.workflowsN', { num: Object.keys(input_linked.workflows).length }));
          break;
        }
        case 'channel:update-members': {
          setModalTitle(i18n.t('channel.contacts', { num: Object.keys(input_linked.contacts).length }));
          break;
        }
      }
    }
  }, [channel, input_linked]);

  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => {
    submitInputs({
      channel: {
        ...channel,
        // not including values like `contacts` and `workflows`
        // will remove their values

        contacts: 'contacts' in input_linked //
          ? Object.keys(input_linked.contacts)
          : channel.contacts,
        workflows: 'workflows' in input_linked //
          ? Object.keys(input_linked.workflows)
          : channel.workflows,
      }
    });
  }

  const submitInputs = ({ channel }) => {
    const request = { isWaiting: false, isAcknowledged: false, issues: null };

    // ? request
    request.isWaiting = true;
    request.isAcknowledged = true;


    modal.onUpdate({ request });
    modal.onRequest('UPDATE_CHANNEL_INLINE', '/contact/channel/' + channel.id, {
      name: channel.name,
      description: channel.description,
      contacts: channel.contacts,
      workflows: channel.workflows.map((local_workflow_id) => (all_workflows_owned[local_workflow_id].workflowId))
    }, 'PUT').then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---
    })
  }

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}

      title={modal_title}
      buttonBack={{text: i18n.t('addContact.cancel')}}
      buttonSubmit={{text: i18n.t('channel.continue')}}
    >
      <Text className="text-md text-secondary-600">{modal_caption}</Text>
      <VStack space="md" className="max-h-[320px] px-[1rem] mx-[-1rem] overflow-y-auto">
        {'workflows' in input_linked && all_workflows.map((entry) => (
          <Checkbox
            key={entry.id}
            defaultIsChecked={entry.id in input_linked.workflows}
            onChange={(value) => {
              value ? (input_linked.workflows[entry.id] = entry) : (delete input_linked.workflows[entry.id]);
              setInputLinked({ ...input_linked });
            }}
            size="md" isInvalid={false} isDisabled={false}
          >
            <CheckboxIndicator className="h-8 w-8">
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            <HStack space="md" className="px-6 h-12 items-center flex-1">
              <VStack >
                <Text className="text-md text-secondary-600 font-[800]">{entry.title}</Text>
                <Text className="text-md text-secondary-600">{i18n.t('showWorkflowScreen.numberOfSteps', { steps: entry.steps.length })}</Text>
              </VStack>
            </HStack>
          </Checkbox>
        ))}

        {'contacts' in input_linked && all_contacts.map((entry) => (
          <Checkbox
            key={entry.id}
            defaultIsChecked={entry.id in input_linked.contacts}
            onChange={(value) => {
              value ? (input_linked.contacts[entry.id] = entry) : (delete input_linked.contacts[entry.id]);
              setInputLinked({ ...input_linked });
            }}
            size="md" isInvalid={false} isDisabled={false}
          >
            <CheckboxIndicator className="h-8 w-8">
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            <HStack space="md" className="px-6 h-12 items-center flex-1">
              <VStack >
                <Text className="text-md text-secondary-600 font-[800]">{entry.toUser.mail}</Text>
                <Text className="text-md text-secondary-600">{entry.toUser.preferredName}</Text>
              </VStack>
            </HStack>
          </Checkbox>
        ))}
      </VStack>
      {'request-failed' in hasIssues && (
        <VStack>
          <Text className="mt-2 text-xs text-error-600">{hasIssues['request-failed']}</Text>
        </VStack>
      )}
    </ModalWrapper>
  );
}
